import { Injectable } from "@angular/core";
import { ReplaySubject } from "rxjs";

@Injectable({ providedIn: "root" })
export class CopilotStateFacade {
  private readonly configSubject = new ReplaySubject<unknown>(1);
  private currentConfig: unknown = null;

  readonly config$ = this.configSubject.asObservable();

  get config(): unknown {
    return this.currentConfig;
  }

  setConfig(config: unknown): void {
    this.currentConfig = config;
    this.configSubject.next(config);
  }
}
